import React, { useState } from "react";
import { Button, Spinner } from "reactstrap";
import { Icon } from "../../components/Component";
import { handleDeleteApis, handlePostApis } from "../../service/Api";

const EMPTY_FAQ = { id: null, question: "", answer: "", sort_order: 0, is_active: 1 };

const FaqRow = ({ faq, index, onSaved, onCancel }) => {
  const [draft, setDraft] = useState(faq);
  const [saving, setSaving] = useState(false);
  const set = (key, value) => setDraft((d) => ({ ...d, [key]: value }));
  const switchId = `hc-faq-${draft.id ?? `new-${index}`}`;

  const save = async () => {
    setSaving(true);
    const res = await handlePostApis("admin/homepage/faq", draft);
    setSaving(false);
    alert(res?.data?.message || "Something went wrong");
    if (res?.data?.success) onSaved();
  };

  const remove = async () => {
    if (!window.confirm("Delete this FAQ?")) return;
    const res = await handleDeleteApis("admin/homepage/faq", { id: draft.id });
    if (res?.data?.success) onSaved();
    else alert(res?.data?.message || res?.message || "Something went wrong");
  };

  return (
    <div className="hc-card is-open">
      <div className="hc-card-head">
        <div className="hc-toggle">
          <span className="hc-title">{draft.id || faq.question ? `FAQ ${index + 1}` : "New FAQ"}</span>
          {!draft.id && faq.question && <span className="hc-badge">Default — save to keep</span>}
          {!draft.is_active && <span className="hc-badge is-hidden">Hidden</span>}
        </div>
        <div className="hc-controls">
          <label className="hc-order">
            Order
            <input
              type="number"
              className="form-control"
              value={draft.sort_order}
              onChange={(e) => set("sort_order", Number(e.target.value))}
            />
          </label>
          <div className="custom-control custom-switch hc-switch">
            <input
              type="checkbox"
              className="custom-control-input"
              id={switchId}
              checked={!!draft.is_active}
              onChange={(e) => set("is_active", e.target.checked ? 1 : 0)}
            />
            <label className="custom-control-label" htmlFor={switchId}>
              Visible
            </label>
          </div>
          {draft.id && (
            <button type="button" className="hc-icon-btn is-danger" onClick={remove} title="Delete">
              <Icon name="trash" />
            </button>
          )}
          {onCancel && (
            <Button color="light" size="sm" onClick={onCancel}>
              Cancel
            </Button>
          )}
          <Button color="primary" size="sm" onClick={save} disabled={saving}>
            {saving ? <Spinner size="sm" /> : "Save"}
          </Button>
        </div>
      </div>
      <div className="hc-card-body">
        <div className="hc-field">
          <label className="hc-label">Question</label>
          <input className="form-control" value={draft.question} onChange={(e) => set("question", e.target.value)} />
        </div>
        <div className="hc-field">
          <label className="hc-label">Answer</label>
          <textarea className="form-control" rows={3} value={draft.answer} onChange={(e) => set("answer", e.target.value)} />
        </div>
      </div>
    </div>
  );
};

const FaqTab = ({ faqs, onSaved }) => {
  const [adding, setAdding] = useState(false);
  const usingDefaults = faqs.length > 0 && faqs.every((f) => !f.id);

  return (
    <>
      {usingDefaults ? (
        <div className="hc-help">
          <Icon name="info" />
          <span>
            These are the default FAQs shown on the site. Once you save any FAQ, the site shows only the FAQs saved here — so save
            each default you want to keep.
          </span>
        </div>
      ) : (
        <p className="hc-intro">These questions appear on the homepage and in Google results (FAQ rich results).</p>
      )}

      {faqs.map((f, i) => (
        <FaqRow key={f.id ?? `default-${i}`} faq={f} index={i} onSaved={onSaved} />
      ))}

      {adding ? (
        <FaqRow
          faq={{ ...EMPTY_FAQ, sort_order: faqs.length + 1 }}
          index={faqs.length}
          onSaved={() => {
            setAdding(false);
            onSaved();
          }}
          onCancel={() => setAdding(false)}
        />
      ) : (
        <button type="button" className="hc-add-btn" onClick={() => setAdding(true)}>
          <Icon name="plus" /> Add FAQ
        </button>
      )}
    </>
  );
};

export default FaqTab;
